export default __webpack_public_path__ + "assets/e4870f5c7fc39f7c3c08d01eaa11a59a.jpeg";